import { observer } from 'mobx-react-lite';
import { useChapterStore } from '../provider/ChapterProvider';
import { twMerge } from 'tailwind-merge';
import { useLessonStore } from '../provider/LessonProvider';

const SentenceProgress = observer((): React.ReactNode => {
    const lessonStore = useLessonStore();
    const chapterStore = useChapterStore();
    const currentNum = chapterStore.currentSentenceNum;
    const totalNum = chapterStore.chapter?.learningContent?.length || 0;

    if (chapterStore.isLoading || totalNum === 0) {
        return (
            <div className="flex h-6 items-center">
                <div className="skeleton h-1 w-full"></div>
            </div>
        );
    }

    return (
        <div className="relative flex h-6 items-center gap-0.5">
            {Array.from({ length: totalNum }, (_, index) => {
                const sentenceNum = index + 1;
                const isCompleted = sentenceNum < currentNum;
                const isCurrent = sentenceNum === currentNum;

                return (
                    <button
                        key={sentenceNum}
                        className="group relative block h-6 flex-1"
                        onClick={() => {
                            if (chapterStore.isAutoPlaying) {
                                chapterStore.stopAutoPlay();
                            }
                            lessonStore?.lessonPlayerRef?.current?.pause();
                            chapterStore.moveToSentence(sentenceNum);
                        }}
                    >
                        <div
                            className={twMerge(
                                `w-full rounded-xs transition-all duration-200`,
                                // 문장 상태에 따라 배경색 변경
                                isCompleted && 'bg-primary/20 h-1', // 완료 문장
                                isCurrent && 'bg-primary/70 h-1.5', // 현재 문장
                                !isCurrent && !isCompleted && 'bg-base-content/10 h-1', // 미완료 문장
                                'group-hover:bg-primary/70', // 호버
                            )}
                            title={`문장 ${sentenceNum}`}
                            aria-label={`문장 ${sentenceNum}로 이동`}
                        />
                        {isCurrent && (
                            <div className="text-primary absolute -top-2 left-1/2 -translate-x-1/2 text-[10px] font-medium whitespace-nowrap">
                                {/* 나중에 여기에 keep 한 아이콘 보여줌 */}
                            </div>
                        )}
                        {/* 호버 시 숫자 표시 */}
                        <div className="text-base-content pointer-events-none absolute -top-2 left-1/2 -translate-x-1/2 text-[10px] whitespace-nowrap opacity-0 transition-opacity group-hover:opacity-100">
                            문장 {sentenceNum}
                        </div>
                    </button>
                );
            })}
        </div>
    );
});

export default SentenceProgress;
